import axios, { AxiosResponse } from 'axios';

import { VariableTypeAndObjectID } from 'common/variables/Variables';

const { CancelToken } = axios;

export enum TemplateLevel {
    System = 1,
    Tenant = 2,
    Location = 3,
    User = 4,
}

export interface Template {
    id: string;
    externalID: string;
    tenantID: number;
    locationUid: number;
    name: string;
    text: string;
    modules: object;
    levels: TemplateLevel[];
    labels: object;
    autorespond: true;
    medias?: object;
    variableTypeAndObjectIDs?: VariableTypeAndObjectID[];
}

const templatesBaseUrl = (tenantId: number): string => {
    return `/api/tenants/${tenantId}/templates`;
};

export let cancelExpandTemplates: any; // eslint-disable-line import/no-mutable-exports

export const expandTemplates = async (tenantId: number, search: object, args: object): Promise<Template[]> => {
    const params: any = { tenantId, search, args };

    const response: AxiosResponse = await axios.get(`${templatesBaseUrl(tenantId)}/expand`, {
        params,
        cancelToken: new CancelToken((cancel) => {
            cancelExpandTemplates = cancel;
        }),
    });

    return response.data;
};
